/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

import { IVodSocuLastViewedPositionServiceRepository } from '../interfaces/IVodSocuLastViewedPositionServiceRepository';
import { VodSocuLastViewedPositionRepositoryImpl } from '../impls/VodSocuLastViewedPositionRepositoryImpl';
import { TServicesParams, TVodSocuLastViewedPositionParams } from '../types';

export class VodSocuLastViewedPositionService
    implements IVodSocuLastViewedPositionServiceRepository
{
    private oVodSocuLVPServiceRepository: VodSocuLastViewedPositionRepositoryImpl;

    constructor(params: TServicesParams) {
        this.oVodSocuLVPServiceRepository = new VodSocuLastViewedPositionRepositoryImpl(params);
    }

    async setSocuLastViewedPosition(
        socuLVPParams: TVodSocuLastViewedPositionParams,
    ): Promise<void> {
        return this.oVodSocuLVPServiceRepository.setSocuLastViewedPosition(socuLVPParams);
    }

    async setVodLastViewedPosition(vodLVPParams: TVodSocuLastViewedPositionParams): Promise<void> {
        return this.oVodSocuLVPServiceRepository.setVodLastViewedPosition(vodLVPParams);
    }
}
